// This file holds configuration variables for the app.

// Set this to 'true' to require login for the main homepage (beta mode).
// Set this to 'false' to make the homepage public for everyone.
export const PROTECT_HOMEPAGE = true;
// max length for audio submissions, in seconds
export const MAX_SUBMISSION_LENGTH = 20;
// Targeting Cookies group ID in OneTrust
export const ONE_TRUST_CONSENT_GROUP = 'C0009';
// min audio recording length accepted
export const MIN_AUDIO_SUBMISSION_LENGTH = 4;
